import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ActiveOrgResolver } from '../organizations/active-org-resolver.service';
import { PrivateComponent } from './private.component';
import { HasDocumentsResolver } from '../documents/has-documents-resolver.service';
import { LanguageResolver } from '../shared/language.resolver';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'organizations/choose',
    pathMatch: 'full',
    data: { hideSidebar: true },
  },
  {
    path: '',
    component: PrivateComponent,
    children: [
      {
        path: 'organizations',
        loadChildren: () =>
          import('../organizations/organizations.module').then(
            (m) => m.OrganizationsModule,
          ),
        data: { sidebarExpanded: false, hideSidebar: true },
      },
    ],
    resolve: {
      l: LanguageResolver,
    },
  },
  { path: '404', component: NotFoundComponent },
  { path: ':id', redirectTo: ':id/dashboard' },
  {
    path: ':id',
    component: PrivateComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
        data: { sidebarExpanded: false },
        resolve: {
          hasDocuments: HasDocumentsResolver,
        },
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('../documents/documents.module').then(
            (m) => m.DocumentsModule,
          ),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('../clients/clients.module').then((m) => m.ClientsModule),
      },
      {
        path: 'items',
        loadChildren: () =>
          import('../items/items.module').then((m) => m.ItemsModule),
      },
      {
        path: 'pricelists',
        loadChildren: () =>
          import('../price-lists/price-lists.module').then(
            (m) => m.PriceListsModule,
          ),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('../payments/payments.module').then((m) => m.PaymentsModule),
      },
      {
        path: 'recurrences',
        loadChildren: () =>
          import('../recurrences/recurrences.module').then(
            (m) => m.RecurrencesModule,
          ),
      },
      {
        path: 'exports',
        loadChildren: () =>
          import('../exports/exports.module').then((m) => m.ExportsModule),
      },
      {
        path: 'import',
        loadChildren: () =>
          import('../import/import.module').then((m) => m.ImportModule),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('../apollo-subscriptions/subscriptions.module').then(
            (m) => m.SubscriptionsModule,
          ),
        data: { sidebarExpanded: false },
      },
      {
        path: 'taxes',
        loadChildren: () =>
          import('../taxes/taxes.module').then((m) => m.TaxesModule),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('../categories/categories.module').then(
            (m) => m.CategoriesModule,
          ),
      },
      {
        path: 'units',
        loadChildren: () =>
          import('../units/units.module').then((m) => m.UnitsModule),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('../orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('../settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'referral',
        loadChildren: () =>
          import('../referrals/referrals.module').then(
            (m) => m.ReferralsModule,
          ),
        data: { sidebarExpanded: false },
      },
      {
        path: 'warehouses',
        loadChildren: () =>
          import('../warehouses/warehouses.module').then(
            (m) => m.WarehousesModule,
          ),
      },
      {
        path: 'balance-sheet',
        loadChildren: () =>
          import('../balance-sheet/balance-sheet.module').then(
            (m) => m.BalanceSheetModule,
          ),
      },
      {
        path: 'guestbook',
        loadChildren: () =>
          import('../guestbook/guestbook.module').then(
            (m) => m.GuestbookModule,
          ),
      },
      {
        path: '404',
        component: NotFoundComponent,
        data: { sidebarExpanded: false },
      },
    ],
    resolve: {
      l: LanguageResolver,
      org: ActiveOrgResolver,
    },
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ActiveOrgResolver],
})
export class PrivateRoutingModule {}
